// extracted by mini-css-extract-plugin
export default {"stepsList":"xaxj0","stepsListItem":"SDXmq","stepsListItemContent":"Dbqvt","stepsListItemActive":"foTo9","stepsListItemCompleted":"_LYH5","icon":"FJUdZ"};